import axios from "axios";

export default {
  get() {
    return axios.get("/api/pubs");
  },
  getActive() {
    return axios.get("/api/pubs/active");
  },
  /**
   * Stocke une publicité avec un fichier image
   * @param {FormData} formData - Formulaire contenant les données de la pub et l'image
   * @returns {Promise} - La réponse de l'API
   */
  storeWithImage(formData) {
    return axios.post("/api/pubs", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  delete(id) {
    return axios.delete(`/api/pubs/${id}`);
  },
  /**
   * Met à jour une publicité avec un fichier image
   * @param {number} id - L'ID de la publicité à mettre à jour
   * @param {FormData} formData - Formulaire contenant les données de la pub et l'image
   * @returns {Promise} - La réponse de l'API
   */
  updateWithImage(id, formData) {
    return axios.put(`/api/pubs/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
